import { ConditionalWrapper, ExpandableText } from "client/Components";
import { MediaQueryKind, useWorkspaceMediaQuery } from "client/Hooks";
import { ReactElement } from "react";
import styles from "./HubCategoryPageContent.module.less";
import { setTrackingId } from "client/Misc/utils";
import { RawHtmlWithHoverableMentions } from "../RawHtmlWithHoverableMentions/RawHtmlWithHoverableMentions";

export type HubCategoryPageContentProps = {
	text: string;
	trackingId: string;
};

export const HubCategoryPageContent = (props: HubCategoryPageContentProps): ReactElement => {
	const {
		text,
		trackingId
	} = props;

	const isMobile: boolean = useWorkspaceMediaQuery(MediaQueryKind.Mobile);

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.root}
		>
			<ConditionalWrapper
				condition={isMobile}
				wrapper={
					(children) => (
						<ExpandableText
							maxLines={5}
							text={<>{children}</>}
							trackingId="expandable-text"
						/>
					)
				}
			>
				<RawHtmlWithHoverableMentions html={text} />
			</ConditionalWrapper>
		</div>
	);
};
HubCategoryPageContent.displayName = "HubCategoryDescription";